// extracted by mini-css-extract-plugin
export var fileUpload = "_gc-1";
export var modalButton = "_gc-0";